module.exports = __webpack_public_path__ + "img/icon-5.96c45e67.png";